import { memo } from 'react';

import QwenIconSVG from '@/assets/qwen-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IQwenIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={QwenIconSVG} {...props} />;

export const QwenIcon = memo(IQwenIcon) as typeof IQwenIcon;
